import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ContentBlockInclusions = lazy(() =>
  import("@scenes/MessageComposition/ContentBlocks/ContentBlockInclusions").then((module) => ({
    default: module.ContentBlockInclusions,
  }))
);

export const contentBlockInclusionsNRO: NavigationRoutingObject = {
  componentFeatureFlippers: [],
  Component: ContentBlockInclusions,
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("content-block-inclusions-nro-heading", "Content Block Inclusions"),
  pageNameForTracking: () => "Content Block Inclusions",
  icon: "nav-system-content-blocks",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/content_blocks/:appGroupId",
};
